/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Cognos Analytics Home (C) Copyright IBM Corp. 2020, 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'ca-content/content/content',
	'../nls/StringResources',
	'react',
	'react-dom'
], function (content, StringResources, React, ReactDOM) {

	class SearchContentPageView {
		constructor(options) {
			this.glassContext = options.glassContext;
			this.el = (options.$el && options.$el[0]) || this._initDomElement();
			this.searchTerm = options.searchTerm;
			this.currentFolderId = options.currentFolderId;
			this.filterType = options.filterType;
			this.filterSearchString = options.filterSearchString;
			this.filterModified = options.filterModified;
		}

		render() {
			const options = {
				glassContext: this.glassContext,
				searchTerm: this.searchTerm,
				currentFolderId: this.currentFolderId,
				filterType: this.filterType,
				filterSearchString: this.filterSearchString,
				filterModified: this.filterModified,
				ref: ref => this.searchPageView = ref
			};
			ReactDOM.render(React.createElement(content.SearchContentPageView, options), this.el);
			return Promise.resolve();
		}

		activate(content) {
			this.updateContentPage(content);
			return Promise.resolve();
		}

		deactivate() {
			return Promise.resolve();
		}

		show() {
			this.el.setAttribute('style', 'display: block;');
		}

		setFocus() { }

		_initDomElement() {
			const el = document.createElement('div');
			el.classList.add('contentPageView');
			return el;
		}

		getTitle() {
			return StringResources.get('searchContentPageTitle');
		}

		updatePerspectiveContext(context) {
			const isContentUpdated = this.updateContentPage(context.content);
			this.glassContext.currentPerspective.updateRenderState(!isContentUpdated);
			if (isContentUpdated) {
				this.glassContext.updateCurrentCachedAppView();
			}
			
		}

		updateContentPage(content) {
			if (content.options && content.options.showCachedSearch) {
				return false;
			}
			let changed = false;
			if (this.searchTerm !== content.searchTerm || !this.searchPageView) {
				this.searchTerm = content.searchTerm;
				changed = true;
			}
			if (this.filterType !== content.filterType || !this.searchPageView) {
				this.filterType = content.filterType;
				changed = true;
			}
			if (this.filterSearchString !== content.filterSearchString || !this.searchPageView) {
				this.filterSearchString = content.filterSearchString;
				changed = true;
			}
			if (this.filterModified !== content.filterModified || !this.searchPageView) {
				this.filterModified = content.filterModified;
				changed = true;
			}
			if (this.currentFolderId !== content.currentFolderId || !this.searchPageView) {
				this.currentFolderId = content.currentFolderId;
				changed = true;
			}

			if (changed) {
				this.render();
				return true;

			} else {
				this.searchPageView.forceUpdate();
				return true;
			}
		}

		getContent() {
			return {
				searchTerm: this.searchTerm,
				filterType: this.filterType,
				filterSearchString: this.filterSearchString,
				filterModified: this.filterModified,
				currentFolderId: this.currentFolderId
			};
		}
	}

	return SearchContentPageView;
});